// BOOTSTRAP
import 'bootstrap'; // importing bootstrap.js
// import bs_reboot from 'bootstrap/scss/bootstrap-reboot.scss';
// import bs_grid from 'bootstrap/scss/bootstrap-grid.scss';
import bs_style from 'bootstrap/scss/bootstrap.scss';

// FONT-AWESOME
import fontawesome from '@fortawesome/fontawesome-free/js/all.js';
import fasolid from '@fortawesome/free-solid-svg-icons';
import faregular from '@fortawesome/free-regular-svg-icons';
import fabrands from '@fortawesome/free-brands-svg-icons';

// PROMISES
import "native-promise-only";

// OBJECTFITIMAGES
import objectFitImages from 'object-fit-images';
objectFitImages();

// TOASTR
import toastr_style from 'toastr/toastr.scss';

// SELECT2
import 'select2/dist/css/select2.min.css';



// WEBPACK FOOTER //
// ./vendor/index.js